import { linkDeAssinaturaServe, type CursoDoAluno } from "../lib/dados";
import { SetaDireita } from "./ui";

// O aviso de curso trancado por contrato pendente (000044).
//
// Fica no topo da tela do curso, acima de tudo, porque enquanto ele estiver ali
// nada abaixo funciona — e um aviso no meio da página deixaria o aluno clicando
// em cards mortos antes de entender por quê.
//
// O texto diz três coisas, nesta ordem: o que está acontecendo, que o acesso NÃO
// foi perdido, e o que fazer. A segunda é a que evita o chamado no suporte: quem
// pagou e vê a tela travada assume que perdeu o que comprou.
//
// O botão só aparece quando existe link de assinatura DE VERDADE — e distinguir
// isso já mordeu uma vez. A primeira heurística era "contém /verificar/ =
// placeholder", porque os provisórios eram `/verificar/<slug>`. Em 14/08 os
// links reais entraram no catálogo (000049)… no formato `/verificar/doc/<uuid>`:
// a ZapSign também usa /verificar/ nos documentos legítimos, e a heurística
// passou a esconder o botão exatamente de quem ele servia. O placeholder de
// verdade se reconhece pelo que ele é — o caminho termina no slug, sem `/doc/`.
// Só a `escola-contabil` continua assim (o link dela ainda não veio).
export default function AvisoContrato({
  curso,
  urlContrato,
}: {
  curso: CursoDoAluno;
  urlContrato?: string | null;
}) {
  const linkServe = linkDeAssinaturaServe(urlContrato);

  return (
    <div
      role="alert"
      className="surface rise mt-6 border-laranja/50 p-6 shadow-[0_2px_6px_rgba(255,153,51,0.08),0_14px_32px_-18px_rgba(255,153,51,0.35)] sm:p-7"
    >
      <div className="flex flex-wrap items-start justify-between gap-5">
        <div className="flex items-start gap-4">
          <span className="grid size-11 shrink-0 place-items-center rounded-[13px] bg-alerta-fundo text-alerta-tinta">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-[23px]" aria-hidden="true">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <path d="M14 2v6h6" />
              <path d="M8 17c1.5-2.5 3-3.5 4-2.5s2 2 4-.5" />
            </svg>
          </span>
          <div className="max-w-xl">
            <h2 className="font-display text-lg font-bold text-titulo">
              Falta assinar o contrato deste curso
            </h2>
            <p className="mt-1.5 text-sm leading-relaxed text-cinza">
              As aulas e as ferramentas de <strong className="text-tinta">{curso.nome}</strong> ficam
              disponíveis assim que a assinatura for concluída.{" "}
              <strong className="text-tinta">O seu acesso não foi perdido</strong> — a matrícula segue
              válida e o prazo continua contando.
            </p>
            {!linkServe && (
              <p className="mt-2 text-sm leading-relaxed text-cinza">
                Para assinar, fale com o suporte pelo canal no rodapé desta página — a gente envia o
                link na hora.
              </p>
            )}
          </div>
        </div>

        {linkServe && (
          <a href={urlContrato!} target="_blank" rel="noreferrer" className="pill-cta">
            Assinar contrato <SetaDireita />
            <span className="sr-only">(abre em outra aba)</span>
          </a>
        )}
      </div>
    </div>
  );
}
